import React, { Dispatch, FC, MouseEvent, SetStateAction, useCallback, useRef, useState } from "react";
import st from './mainLinkAccount.module.scss'
import { IconBox, Type as T } from "@infobis/ui-styles-utils";
import cn from "classnames";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { useActions } from "@hooks/useActions";
import logger from "@utils/logger";
import { Link } from 'react-router-dom';
import OrganizationsTree from "@elements/OrganizationsTree/OrganizationsTree";
import { authenticateOrganization, Organization, TNode } from "@pages/auth/authPage/AuthPage";
import { AsClientNode } from "@api/auth/OrganizationService";
import { Portal } from "@infobis/ui-styles-utils";
import { PortalComputedProps } from "@infobis/ui-styles-utils/components/Portal/Portal";
import { AuthState } from "@infobis/as-react-auth";
import colors from "@infobis/ui-styles-utils/colors";

interface IMainLinkAccount {
    isFull?: boolean
    openMenu: Dispatch<SetStateAction<boolean>>
}
const root = document.getElementById("root")!
const log = logger.getLogger("main.link.account")
type MenuItem = { id: number, title: string, click: () => void, icon: T.IconName, color?: T.Color }
type UserMenuProps<T> = PortalComputedProps<T> & {
    onClose: () => void
    menu : MenuItem[]
}
const UserMenu = React.forwardRef<HTMLUListElement, UserMenuProps<HTMLUListElement>>((props, ref) => {
    return <ul
        {...props as React.HTMLAttributes<HTMLUListElement>}
        ref={ref}
        className={st.menu}>{props.menu.map((m) => <li
        className={cn(st.menu__item)}
        onClick={m.click}
        key={m.id}>
        <IconBox
            icon={m.icon || T.IconName.KebabHorizontal}
            color={m.color}
            size={T.Size.LARGE}
            sizePadding={T.Size.SMALL}
        />
        {m.title}</li>)}
    </ul>
})
const MainLinkAccount: FC<IMainLinkAccount> = (props) => {
    let {
        isFull,
        openMenu
    } = props
    // TODO Rename that ugly and unclear `isFull` variable
    const isAppMenuOpen = isFull
    const authState: AuthState = useTypedSelector(state => state.auth)
    const { removeToken } = useActions()
    const [isUserMenuOpen, setUserMenuOpen] = useState<boolean>(false)
    const iconRef = useRef<HTMLElement>(null)
    const avatarRef = useRef<HTMLDivElement>(null)

    const emptyFn = () => log.warn('Not implemented...')
    
    const menu : MenuItem[] = [
        { id: 1, title: 'Инструкция', click: emptyFn, icon: T.IconName.Question },
        { id: 2, title: 'Новости программы', click: emptyFn , icon: T.IconName.News},
        { id: 3, title: 'Версия программы', click: emptyFn, icon: T.IconName.Info },
        { id: 4, title: 'Пересчет по источнику', click: emptyFn, icon: T.IconName.Calculate },
        { id: 5, title: 'Выйти из программы', click: () => removeToken(), icon: T.IconName.Logout, color: colors.TYPO_ALERT},
    ]

    const userName = authState.accessToken?.userInfo.name || "!"

    const { authorizedCompany, authorizedDepartment } = useTypedSelector((state) => state.auth);
    const organizations: AsClientNode[] = useTypedSelector((state) => state.organizations.tree ? state.organizations.tree.data : []);
    const { authenticateOrganizationAction } = useActions()
    const [isDepartmentsVisible, setDepartmentsVisible] = useState(false)

    const organizationNameRef =  useRef<HTMLDivElement>(null)
    const onOrganizationChoose = useCallback(async (organizationNode: TNode<Organization> | undefined) => {
        if(organizationNode && organizations.length) {
            await authenticateOrganization(organizationNode, organizations, authenticateOrganizationAction)
        }
    }, [organizations])

    const prevent = <T extends HTMLElement,>(fn: (e: MouseEvent<T>) => void) => (e: MouseEvent<T>) =>  {
        e.preventDefault()
        fn(e)
    }

    return (
        <div className={st.account}>
            <div
              ref={avatarRef}
              onClick={(e) => openMenu(!isAppMenuOpen)}
              onContextMenu={prevent(() => setUserMenuOpen(!isAppMenuOpen))}
              className={cn(st.iconMenu, st.avatar)}
            >
                {userName[0]}
            </div>
            {isAppMenuOpen && <><div className={st['account__text']}>
                <Link className={st['account__text-name']} to="/user">{userName}</Link>
                <div className={st['account__text-organization']} ref={organizationNameRef} onClick={() => setDepartmentsVisible(true)}>{authorizedDepartment?.name || authorizedCompany?.title}</div>
            </div>
                <span ref={iconRef} onClick={() => setUserMenuOpen(v => !v)}><IconBox
                    icon={T.IconName.KebabVertical}
                    color={colors.CONTROL_DEFAULT_MAIN_MENU_ICON}
                    size={T.Size.LARGE}
                    className={st.iconDots}
                    sizePadding={T.Size.SMALL}
                /></span>
            </>}
            {
                <Portal
                    container={root}
                    targetRef={isAppMenuOpen ? iconRef : avatarRef}
                    trigger={isUserMenuOpen}
                    offsets={{ x: 15 }}
                    position={'right-end'}
                    component={(props: PortalComputedProps<HTMLUListElement>) =>
                        <UserMenu {...props} menu={menu} onClose={() => setUserMenuOpen(false)}/>
                }
                    onOutsideClick={() => setUserMenuOpen(false)}/>
            }
            {
                <Portal
                    container={root}
                    targetRef={organizationNameRef}
                    trigger={isDepartmentsVisible}
                    offsets={{ x: 55 }}
                    position={'right-end'}
                    component={(props: PortalComputedProps<HTMLDivElement>) => <OrganizationsTree
                        {...props}
                        onChoose={onOrganizationChoose}
                        onClose={() => setDepartmentsVisible(false)}
                    />}
                    onOutsideClick={() => setDepartmentsVisible(false)}/>
            }
        </div>
    )
}
export default MainLinkAccount;